import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoBoundaryTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoBoundaryTypeModel._instance == null) GeoBoundaryTypeModel._instance = new GeoBoundaryTypeModel(authManager);
        return GeoBoundaryTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-boundary-types', 'model-sections/geo-boundary-types/codelist');

        this.entityName = 'model-sections.GeoBoundaryType';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Boundary Type';
        this.setLabel = 'Boundary Types';

        this.browser = {
            name: 'default-model-sections-geoboundarytype-browser',
            moduleName: 'default-model-sections-geoboundarytype-browser',
            moduleTitle: 'Boundary Types',
            moduleStateSlotName: 'default-model-sections-geoboundarytype-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoboundarytype-editor',
            moduleName: 'default-model-sections-geoboundarytype-editor',
            moduleTitle: 'Boundary Type',
            moduleStateSlotName: 'default-model-sections-geoboundarytype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
